import { Box, useMediaQuery } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { SobreNosSubPageEnum } from "../../../Empresa/SobreNosSubPageEnum";
import bannerEnergia1 from "../../../../assets/images/banner_energia_1.png";
import bannerFeitosDeGente from "../../../../assets/images/HOME_pessoas_unidas_2.png";
import bannerTelecom1 from "../../../../assets/images/banner_telecom_1.png";
import bannerTelemontComVc from "../../../../assets/images/home_com_vc_em_todos.png";
import DefaultButton from "../../../../components/buttons/default-button";
import DefaultText from "../../../../components/typography/default-text";
import HomeBanner from "./components/home-banner";
import MinorHomeBanner from "./components/minor-home-banner";
import OurNumbersGrid from "./components/our-numbers-grid";
import styles from "./home.module.css";

const Home = () => {

  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width: 1280px)");

  return (
    <>
      <div className={styles["sub-page-content"]}>
        <HomeBanner />

        <div className={styles["text-content-row-wrap"]} style={{ display: 'flex', gap: '24px' }}>
          <Box display={"flex"} flexDirection={"column"} gap={"16px"}>
            <DefaultText size="xs">
              <span style={{ fontFamily: 'Montserrat-Regular', fontSize: "20px", fontWeight: 500, letterSpacing: "0.1em" }}>SERVIÇOS</span>
            </DefaultText>
            <DefaultText size="medium" maxWidth={"463px"} lineHeight="var(--font-size-large)">
              <span style={{ fontFamily: 'Montserrat-Regular', fontSize: "32px", fontWeight: 500 }}>Atendemos com eficiência os principais </span>
              <span style={{ fontFamily: 'Montserrat-SemiBold', fontSize: "32px", fontWeight: 700, fontStyle: 'italic' }}>provedores de internet, operadoras de telefonia e distribuidoras de energia do Brasil.</span>
            </DefaultText>
          </Box>
          <DefaultText maxWidth={"480px"} size="small" style={{ marginTop: '44px' }}>
            <span style={{ fontFamily: 'Montserrat-Regular', fontSize: "20px", fontWeight: 400 }}>Nossas soluções integradas e inovadoras em telecom e energia, com presença em todo o território nacional, garantem excelência e confiabilidade em cada entrega.</span>
          </DefaultText>
        </div>

        <div className={styles["banner-content-row-wrap"]}>
          <MinorHomeBanner image={bannerTelecom1} title={"Telecom"} subtitle={"Soluções integradas em telecomunicação com capilaridade nacional."}
            onClick={() => { navigate("/servicos/telecom") }}
          />
          <MinorHomeBanner image={bannerEnergia1} title={"Energia"} subtitle={"Serviços de distribuição e manutenção da rede elétrica."}
            onClick={() => { navigate("/servicos/energia") }}
          />
        </div>

        <div className={styles["text-content-row-wrap"]}>
          <Box display={"flex"} flexDirection={"column"} gap={"16px"} justifyContent={"center"}>
            <DefaultText size="xs">
              <span style={{ fontFamily: 'Montserrat-Regular', fontSize: "20px", fontWeight: 500, letterSpacing: "0.1em" }}>EMPRESA</span>
              </DefaultText>
            <DefaultText size="medium" maxWidth={"430px"} lineHeight="var(--font-size-medium)">
              <span style={{ fontFamily: 'Montserrat-Regular', fontSize: "32px", fontWeight: 500 }}>Números que </span>
              <span style={{ fontFamily: 'Montserrat-SemiBold', fontSize: "32px", fontWeight: 700, fontStyle: 'italic' }}>nos representam</span>
            </DefaultText>
          </Box>
          <DefaultText maxWidth={"480px"} size="small" marginTop={"24px"}>
            <span style={{ fontFamily: 'Montserrat-Regular', fontSize: "20px", fontWeight: 400 }}>Principais dados que refletem o impacto e a excelência da Telemont.</span>
          </DefaultText>
        </div>

        <OurNumbersGrid />

        <div/>

        <div className={styles["telemont-com-voce-banner"]}>
         <img src={bannerTelemontComVc} alt="Imagem de conteúdo" className={!isMobile ? styles["telemont-com-voce-image"] : ''} style={{objectFit: "contain", width: isMobile ? "100%" : "auto", maxWidth: isMobile ? "100%" : "auto"}}/>
          <Box display={"flex"} flexDirection={"column"} gap={"16px"} style={{ paddingTop: "50px", boxSizing: "border-box", maxWidth: "100%" }}>
            <DefaultText maxWidth={"370px"}>
               <span style={{ fontFamily: 'Montserrat-SemiBold', fontSize: "32px", fontWeight: 700}}>TELEMONT </span>
               <span style={{ fontFamily: 'Montserrat-Regular', fontSize: "32px", fontWeight: 500 }}>com você <br /></span>
               <span style={{ fontFamily: 'Montserrat-SemiBold', fontSize: "32px", fontWeight: 700, fontStyle: 'italic' }}>em todos os lugares</span>
            </DefaultText>
            <DefaultText maxWidth={"489px"}>
              <span style={{ fontFamily: 'Montserrat-Regular', fontSize: "20px", fontWeight: 400 }}>
                 Com foco em eficiência, velocidade e precisão, ampliamos constantemente nossa rede de fibra óptica e serviços para atender às demandas de um mundo em constante transformação.
              </span>
            </DefaultText>
            <DefaultButton
              variant={"outlined"}
              onClick={() => {
                navigate("/empresa/sobre-nos", {
                  state: { initialSobreNosSubPage: SobreNosSubPageEnum.Unidades },
                });
              }}
            >
              <span style={{ fontFamily: 'Montserrat-Regular'}}>Saiba Onde Estamos </span>
            </DefaultButton>
          </Box>
        </div>
      </div>
      <div className={styles["telemont-feitos-de-gente-banner"]}>
        <Box display={"flex"} flexDirection={"column"} gap={"16px"} style={{ boxSizing: "border-box", maxWidth: "100%" }}>
          <DefaultText maxWidth={"630px"}>
            <span style={{ fontFamily: 'Montserrat-Regular', fontSize: "32px", fontWeight: 500 }}>Pessoas unidas por uma  </span>
            <span style={{ fontFamily: 'Montserrat-SemiBold', fontSize: "32px", fontWeight: 700, fontStyle: 'italic' }}><br />TELEMONT cada vez melhor!</span>
          </DefaultText>
          <DefaultText maxWidth={"580px"} size="small">
            <span style={{ fontFamily: 'Montserrat-Regular', fontSize: "20px",  fontWeight: 400}}>
            O respeito à vida, a busca pela diversidade e a
            valorização das pessoas são pilares que sustentam
            nossa organização. Nossos colaboradores são a
            razão do reconhecimento da Telemont no
            mercado. Temos orgulho de cultivar uma cultura
            focada na qualidade de vida e no bem-estar de
            nossas equipes.</span>
          </DefaultText>
          <DefaultButton variant={"contained"} onClick={() => { navigate('/empresa/pessoas') }}>Saiba Mais</DefaultButton>
        </Box>
        <img src={bannerFeitosDeGente} alt={"Banner de operária com sorriso"} className={styles["telemont-feitos-de-gente-banner-image"]} />
      </div>
      {/* <Midia /> */}
    </>
  );
};

export default Home;